<template>
    <span v-if="hydrated">
        <v-row
            dense
            v-for="groupIterator in fieldsInGroup"
            :key="'groupField' + (groupIterator-1)"
        >
            <v-col
                cols="12"
                :md="groupInline ? '6' : '12'"
                v-for="(field, fieldIndex) in groupFields"
                :key="fieldIndex"
            >
                <span v-if="field.type === 'text'">
                    <ValidationProvider
                        rules="max:255"
                        v-slot="{ errors }"
                    >
                        <v-text-field
                            :label="getFieldName(field.name, groupIterator)"
                            @change="emitFieldData"
                            :error-messages="errors"
                            :name="'field' + fieldIndex + 'Data[]'"
                            v-model="dataArray[fieldIndex][groupIterator-1]"
                            outlined
                        />
                    </ValidationProvider>
                </span>

                <span v-if="field.type === 'textarea'">
                    <ValidationProvider
                        rules="max:10000"
                        v-slot="{ errors }"
                    >
                        <v-textarea
                            :label="getFieldName(field.name, groupIterator)"
                            @change="emitFieldData"
                            :error-messages="errors"
                            :name="'field' + fieldIndex + 'Data[]'"
                            v-model="dataArray[fieldIndex][groupIterator-1]"
                            outlined
                        />
                    </ValidationProvider>
                </span>
            </v-col>
        </v-row>
    </span>
</template>

<script>
import InputBoilerplate from '@/views/Common/Input/InputBoilerplate';
import InputGroupBoilerplate from '@/views/Common/Input/Groups/InputGroupBoilerplate';
export default {
    mixins: [ InputBoilerplate, InputGroupBoilerplate ],
};
</script>
